
		export default class PageState{
			//模板生成============================================================================
			self:any = null;
			title: string = "";
			//============================================================================
			isLogined: boolean = false;
			currentClickEmotionPackage: any = null; //当前点击的发音包
			currentClickEmotionObj: any = null; //
			allSpeakerList: any = []; //
			emotionObj:Object={};
			domainMapObject:Object={};
			speakerInfo:Object={}

			refreshing: boolean = false;
			loading: boolean = false;
			finished: boolean = false;
			
		}